__turbopack_context__.v({
  "footer": "styles-module__ERe6FW__footer",
  "radioGroup": "styles-module__ERe6FW__radioGroup",
  "radioGroupWithSubtitles": "styles-module__ERe6FW__radioGroupWithSubtitles",
});
